import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./component/utils/Navbar";
import Sidebar from "./component/sideBarMenu/sideBarMenu";

const Home = () => {
  return (
    <div className="flex flex-col h-screen">
      <Navbar />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 overflow-auto p-10 bg-white">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Home;
